import { render, staticRenderFns } from "./Remark.vue?vue&type=template&id=1a876ada&scoped=true&"
import script from "./Remark.vue?vue&type=script&lang=ts&"
export * from "./Remark.vue?vue&type=script&lang=ts&"
import style0 from "./Remark.vue?vue&type=style&index=0&id=1a876ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a876ada",
  null
  
)

export default component.exports